import React from 'react';
import { motion } from 'framer-motion';
import { navItems } from '../../data/navigation';
import { ScreenId } from '../../types/navigation';
import { ObjectIcon } from './ObjectIcon';
interface AppNavBarProps {
  active: ScreenId;
  onChange: (id: ScreenId) => void;
}
export function AppNavBar({
  active,
  onChange
}: AppNavBarProps) {
  return <nav className="flex h-10 items-stretch border-b border-sf-border bg-white shadow-[0_2px_3px_rgba(0,0,0,0.06)]" aria-label="Commissions app" data-id="element-785" data-mp="imt9kd9n0mgr">
      <div className="flex items-center gap-3 pl-3 pr-6" data-id="element-786" data-mp="8qzyyzfhb31m">
        <button type="button" aria-label="App Launcher" className="grid grid-cols-3 gap-[3px] rounded p-1.5 transition-colors duration-150 ease-out hover:bg-sf-bg" data-id="element-787" data-mp="8sksclq24fxw">
          {Array.from({
          length: 9
        }).map((_, index) => <span key={index} className="h-[4px] w-[4px] rounded-full bg-sf-weak" data-id="element-788" data-mp="3h6jmrixdrt9a" data-mpi={index} />)}
        </button>
        <span className="whitespace-nowrap text-lg text-sf-text" data-id="element-789" data-mp="3m5w79x0s4o8p">Commissions</span>
      </div>
      <div role="tablist" aria-label="Screens" className="flex min-w-0 items-stretch overflow-x-auto" data-id="element-790" data-mp="sfeo89x98joq">
        {navItems.map(item => {
        const isActive = item.id === active;
        return <button key={item.id} id={`nav-tab-${item.id}`} type="button" role="tab" aria-selected={isActive} aria-controls="app-screen" onClick={() => onChange(item.id)} className={`relative flex items-center gap-2 whitespace-nowrap px-4 text-[13px] transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sf-blue ${isActive ? 'bg-sf-blue-light/60 font-semibold text-sf-text' : 'text-sf-text hover:bg-sf-bg'}`} data-id="element-791" data-mp="11gw1lkja279q">
              <ObjectIcon icon={item.icon} bg={item.iconBg} size="xs" data-id="element-792" data-mp="3m50h7umq1ly8" />
              {item.label}
              {item.audience && <span className="font-normal text-sf-weak" data-id="element-793" data-mp="3i3f9sosyhzvf">· {item.audience}</span>}
              {isActive && <motion.span layoutId="nav-active-bar" transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="absolute inset-x-0 bottom-0 h-[3px] bg-sf-blue" data-id="element-794" data-mp="1q3fb4k04k6wu" />}
            </button>;
      })}
      </div>
    </nav>;
}